/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Lazy loading of the component PageAuth ServiceAccess
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./PageAuthServiceAccess'), undefined);
